import { Flex, HStack, Select, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

import { PartnerCard } from './components';

export const HelpSupport = () => {

    const [data] = useState([
        {
            name: 'TechStackLab',
            category: 'it consulting',
            email: 'support@techstacklab.co.za',
            phone: '0761958601',
            website: 'www.techstacklab.co.za',
            services: ['website', 'hosting'],
            requestable: true
        },
        {
            name: 'T Accounting',
            category: 'finance',
            email: 'support@taccounting.co.za',
            phone: '0761958601',
            website: 'www.taccounting.co.za',
            services: ['audit', 'company registration'],
            requestable: true
        },
        {
            name: 'Marketing Guru',
            category: 'marketing',
            email: 'support@marketingguru.co.za',
            phone: '0761958601',
            website: 'www.marketingguru.co.za',
            services: ['Branding', 'social media marketing'],
            requestable: true
        },
        {
            name: 'NG Finance',
            category: 'finance',
            email: 'support@ngfinance.co.za',
            phone: '0761958601',
            website: 'www.ngfinance.co.za',
            services: ['loan'],
            requestable: true
        },
        {
            name: 'Sidney Repairs',
            category: 'workshop',
            email: 'support@srepairs.co.za',
            phone: '0761958601',
            website: 'www.srepairs.co.za',
            services: ['panel beating', 'service and maintenance', 'towing'],
            requestable: true
        },
        {
            name: 'iKhokha',
            category: 'finance',
            email: 'support@ikhokha.com',
            phone: '0761958601',
            website: 'www.ikhokha.com',
            services: ['payments', 'invoicing', 'online store'],
            requestable: false
        },
        {
            name: 'Yoco',
            category: 'finance',
            email: 'support@yoco.com',
            phone: '0761958601',
            website: 'www.yoco.com',
            services: ['payments', 'invoicing', 'online store'],
            requestable: false
        }
    ]);

    return (
        <Flex justifyContent={'center'}>
            <Stack borderRadius={6} p={6} maxW={'5xl'}>
                <HStack justifyContent={'space-between'}>
                    <Text fontSize={'xl'} fontWeight={'medium'}>Help and Support</Text>
                </HStack>
                <Text pb={4} color={'gray.500'}>These Partners/Providers are here to make sure that your business is a success.</Text>
                <Stack mb={2}>
                    <Text>Filter:</Text>
                    <Select
                        placeholder='Select category'
                        bgColor={'white'}
                        maxW={250}
                    >
                        <option value='it consulting'>IT Consulting</option>
                        <option value='marketing'>Marketing</option>
                        <option value='finance'>Finance</option>
                        <option value='car rental'>Car Rental</option>
                        <option value='tracker'>Tracker</option>
                        <option value='referal'>Referal</option>
                    </Select>
                </Stack>
                <br />
                <SimpleGrid columns={[1, 1, 2, 2]} spacing={4}>
                    {
                        data.map((partner: any, index: number) => (
                            <PartnerCard key={index} {...partner} />
                        ))
                    }
                </SimpleGrid>
            </Stack>
        </Flex>
    );
};